"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Button_1 = __importDefault(require("@components/Button"));
var validator_1 = __importDefault(require("@utils/validator"));
var react_hook_form_1 = require("react-hook-form");
var clsx_1 = __importDefault(require("clsx"));
var react_redux_1 = require("react-redux");
var settingsSlice_1 = require("@features/SettingsPage/state/settingsSlice");
var _store_1 = require("@store");
var date_fns_1 = require("date-fns");
var RenewApiKeyModal_1 = __importDefault(require("./RenewApiKeyModal"));
var EvaTable_1 = __importDefault(require("@/react-app/common/components/EvaTable"));
var date_1 = require("@/react-app/common/utils/date/date");
function ApiIntegration(props) {
    var _a;
    var domain = props.domain, angularJsDependencies = props.angularJsDependencies;
    var hasClipboardSupport = !!navigator.clipboard;
    var dispatch = (0, _store_1.useAppDispatch)();
    var loading = (0, react_redux_1.useSelector)(settingsSlice_1.loadingSelector);
    var error = (0, react_redux_1.useSelector)(settingsSlice_1.errorSelector);
    var activeApiKeys = (0, react_redux_1.useSelector)(settingsSlice_1.activeApiKeysSelector) || [];
    var apiKeyRenewableAt = (0, react_redux_1.useSelector)(settingsSlice_1.apiKeyRenewableAtSelector) || null;
    var apiKeyCanBeRenewed = apiKeyRenewableAt ? (0, date_fns_1.isAfter)(new Date(), new Date(apiKeyRenewableAt)) : true;
    var webhookUrl = (0, react_redux_1.useSelector)(settingsSlice_1.webhookUrlSelector) || '';
    var webhookToken = (0, react_redux_1.useSelector)(settingsSlice_1.webhookTokenSelector) || '';
    var webhookTokenElement = (0, react_1.useRef)(null);
    var _b = __read((0, react_1.useState)(false), 2), isApiRenewalModalOpen = _b[0], setIsApiRenewalModalOpen = _b[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    var timeZone = (0, date_1.getUserTimezone)();
    var _c = (0, react_hook_form_1.useForm)({ mode: 'onChange' }), register = _c.register, handleSubmit = _c.handleSubmit, errors = _c.formState.errors;
    var columnRenderer = function (row, column, index) {
        var _a;
        var isDateColumn = column === 'expiredAt' || column === 'createdAt';
        var rawValue = row[column];
        if (!isDateColumn) {
            return react_1.default.createElement("td", { key: index }, rawValue);
        }
        var date = new Date(rawValue);
        var showTooltip = date.getDate() === 15 && date.getMonth() + 1 === 4 && date.getFullYear() === 2025;
        return (react_1.default.createElement("td", { key: index }, rawValue ? (react_1.default.createElement("div", { className: "api-integration-date-container" },
            react_1.default.createElement("div", { title: (_a = t('DASHBOARD.STATISTICS.TIMEZONE_TOOLTIP_R18N', { timeZone: timeZone })) !== null && _a !== void 0 ? _a : '' }, (0, date_1.formatDate)(date)),
            showTooltip && (react_1.default.createElement("div", { className: "eva-tooltip-container--center" },
                react_1.default.createElement("i", { className: "eva-tooltip-icon" }),
                react_1.default.createElement("div", { className: "eva-tooltip" }, t('settings:API_INTEGRATION.CREATION_DATE_TOOLTIP')))))) : ('Never')));
    };
    var currentTeamRole = angularJsDependencies.CurrentUser.roles.find(function (r) { return r.domain === domain; });
    var isAdmin = (currentTeamRole === null || currentTeamRole === void 0 ? void 0 : currentTeamRole.role) === 'Admin';
    var getSettings = function () { return dispatch((0, settingsSlice_1.fetchSiteDetails)(domain)); };
    var onSubmit = function (_a) {
        var webhookUrl = _a.webhookUrl;
        return dispatch((0, settingsSlice_1.persistWebhookUrl)(domain, webhookUrl));
    };
    var copyWebhookToken = function () {
        if (webhookTokenElement.current && hasClipboardSupport) {
            webhookTokenElement.current.select();
            navigator.clipboard.writeText(webhookToken);
        }
    };
    (0, react_1.useEffect)(function () {
        getSettings();
    }, [domain]);
    return (react_1.default.createElement("div", { className: "col-xs-9 component" },
        react_1.default.createElement("div", { className: "api-integration-settings" },
            react_1.default.createElement("div", { className: "setting__title" }, t('settings:API_INTEGRATION.TITLE')),
            error && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", null, t('settings:FAILED_TO_LOAD_SETTINGS_MESSAGE')),
                react_1.default.createElement(Button_1.default, { onClick: getSettings, text: t('settings:GENERAL.TRY_AGAIN_BUTTON') }))),
            !error && !loading && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "api-integration-settings__item" },
                    react_1.default.createElement("label", { className: "setting__subtitle" }, t('settings:API_INTEGRATION.API_KEY_TEXT')),
                    react_1.default.createElement("p", null,
                        react_1.default.createElement(react_i18next_1.Trans, { ns: "settings", i18nKey: "API_INTEGRATION.API_KEY_DESCRIPTION", components: [
                                react_1.default.createElement("a", { className: "eva-link-primary", href: "http://besedo.com/api-documentation/#headers", target: "_blank", rel: "noreferrer", key: "api-doc-link" }),
                            ] })),
                    react_1.default.createElement("div", { className: "api-integration-settings__api-head" },
                        react_1.default.createElement("p", null, t('settings:API_INTEGRATION.API_KEY_COUNT', { COUNT: activeApiKeys.length })),
                        isAdmin && apiKeyCanBeRenewed && (react_1.default.createElement(Button_1.default, { text: t('settings:API_INTEGRATION.RENEW_BUTTON'), onClick: function () { return setIsApiRenewalModalOpen(true); }, className: "btn" }))),
                    activeApiKeys.length > 0 && (react_1.default.createElement("div", null,
                        react_1.default.createElement(EvaTable_1.default, { data: __spreadArray([], __read((activeApiKeys !== null && activeApiKeys !== void 0 ? activeApiKeys : [])), false), columns: [
                                {
                                    label: t('settings:API_INTEGRATION.MASKED'),
                                    property: 'masked',
                                    defaultSort: 'asc',
                                },
                                {
                                    label: t('settings:API_INTEGRATION.CREATED_AT'),
                                    property: 'createdAt',
                                    defaultSort: 'desc',
                                },
                                {
                                    label: t('settings:API_INTEGRATION.EXPIRED_AT'),
                                    property: 'expiredAt',
                                    defaultSort: 'desc',
                                },
                            ], columnRenderer: columnRenderer, domain: domain, entity: "lists", defaultTableSorting: { createdAt: 'desc' }, limit: 5, currentUser: angularJsDependencies.CurrentUser, removeStrips: true }))),
                    !isAdmin && (react_1.default.createElement("p", { className: "api-integration-settings__no-permission" }, t('settings:API_INTEGRATION.ADMIN_ONLY_TEXT'))),
                    !apiKeyCanBeRenewed && apiKeyRenewableAt && isAdmin && (react_1.default.createElement("p", { className: "api-integration-settings__no-permission" },
                        t('settings:API_INTEGRATION.API_KEY_COOLDOWN'),
                        ' ',
                        react_1.default.createElement("span", { className: "eva-tooltip-container" },
                            (0, date_fns_1.formatDistanceToNow)(new Date(apiKeyRenewableAt), { addSuffix: true }),
                            react_1.default.createElement("span", { className: "eva-tooltip" }, (0, date_1.formatDate)(new Date(apiKeyRenewableAt))))))),
                react_1.default.createElement("div", { className: "api-integration-settings__item" },
                    react_1.default.createElement("label", { className: "setting__subtitle" }, t('settings:API_INTEGRATION.WEBHOOK_TEXT')),
                    react_1.default.createElement("p", null,
                        react_1.default.createElement(react_i18next_1.Trans, { ns: "settings", i18nKey: "API_INTEGRATION.WEBHOOK_DESCRIPTION", components: [
                                react_1.default.createElement("a", { className: "eva-link-primary", href: "http://besedo.com/api-documentation/#web-hook", target: "_blank", rel: "noreferrer", key: "webhook-doc-link" }),
                            ] })),
                    react_1.default.createElement("form", { className: "api-integration-settings__item__container" },
                        react_1.default.createElement("input", __assign({ className: (0, clsx_1.default)('api-integration-settings__item__input', errors.webhookUrl && 'eva-input--invalid') }, register('webhookUrl', {
                            validate: function (value) { return validator_1.default.isWebhookUrl(value) || value === ''; },
                        }), { defaultValue: webhookUrl })),
                        react_1.default.createElement(Button_1.default, { text: t('settings:API_INTEGRATION.SAVE_BUTTON'), onClick: handleSubmit(onSubmit), disabled: !!errors.webhookUrl, className: "btn" })),
                    react_1.default.createElement("p", { className: "setting__error" }, ((_a = errors.webhookUrl) === null || _a === void 0 ? void 0 : _a.type) === 'validate' && t('settings:API_INTEGRATION.ERROR.INVALID_URL'))),
                react_1.default.createElement("label", { className: "setting__subtitle" }, t('settings:API_INTEGRATION.WEBHOOK_TOKEN_TEXT')),
                react_1.default.createElement("div", { className: "api-integration-settings__item__container" },
                    react_1.default.createElement("input", { className: "api-integration-settings__item__input", value: webhookToken, readOnly: true, ref: webhookTokenElement }),
                    hasClipboardSupport && (react_1.default.createElement(Button_1.default, { text: t('settings:API_INTEGRATION.COPY_BUTTON'), onClick: copyWebhookToken, className: "btn" }))))),
            react_1.default.createElement(RenewApiKeyModal_1.default, { isOpen: isApiRenewalModalOpen, setIsOpen: setIsApiRenewalModalOpen, hasClipboardSupport: hasClipboardSupport, domain: domain }))));
}
exports.default = ApiIntegration;
